import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";

export default function AmbulancePartners({ content }) {
  return (
    <div id="ambulancePartners">
      <div className="subtitle">{content.subtitle}</div>
      <div className="title">{content.title}</div>
      <div className="description">{content.description}</div>
      <div className="imageWrap">
        {content.imageList.map((image, i) => (
          <LazyLoadImage key={i} alt="logo" effect="blur" src={image.media?.url} />
        ))}
      </div>
      <Link className="buttonText" to={slugToCountryPathname(content.buttonLink)}>
        {content.buttonText}
      </Link>
    </div>
  );
}
